import React from 'react'
import { Field } from 'redux-form'
import isRequired from 'lib/isRequired'
import ImportantMessage from 'components/ImportantMessage'
import Form from 'components/Form'
import Card from 'components/Card'
import CardWithHeader from 'components/CardWithHeader'
import TextField from 'components/TextField'
import CheckBox from 'components/CheckBox'
import AvatarField from 'components/AvatarField'
import ModalScreenLayout from 'navigation-ui/ModalScreenLayout'
import { createTagFields } from 'components/TagFields'
import TagIcon from 'icons/TagIcon'
import Next from './Next'
import styles from './CreateGroupPage.css'
import { useProfile } from 'profile'

const isNotUploading = function (field, fields, props) {
  if (field && field.file) {
    return 'profile.avatar_is_uploading'
  }
}

const isNotError = function (field, fields, props) {
  if (field && field.error) {
    return error.message
  }
}

const CoverImageField = props => <AvatarField {...props} showLabel={false} />

const CommunityField = () => {
  const { profile } = useProfile()
  if (!profile || profile.role !== "ADMIN") {
    return null
  }
  return (
    <Field
      name="community"
      component={CheckBox}
      label="group.create.community"
      on_placeholder="group.create.accessible_by_all_users"
      off_placeholder="group.create.members_are_invited"
    />
  )
}

const CreateOrEditGroupPage = ({
  isEditMode,
  destroy,
  remoteSubmit,
  handleSubmit
}) => {
  return (
    <ModalScreenLayout
      titleLabel={
        isEditMode
          ? 'group.edit.basics_page_title'
          : 'group.create.basics_page_title'
      }
      back={false}
      onBeforeClose={destroy} // clears the form
      right={
        <Next
          label={isEditMode ? 'group.edit.finish' : 'group.create.next'}
          onClick={remoteSubmit}
        />
      }
    >
      <Form onSubmit={handleSubmit} className={styles.create_group_form}>
        <Card className={styles.image_and_name}>
          <Field
            name="image"
            component={CoverImageField}
            label="group.create.cover_image_field"
            validate={[isNotUploading, isNotError]}
          />
          <div>
            <Field
              name="name"
              required="true"
              validate={[isRequired]}
              placeholder="group.create.name_placeholder"
              component={TextField}
              type="text"
              inputProps={{
                maxLength: 60,
                size: 5
              }}
              label="group.create.name_field"
            />
            <Field
              name="members_read_only"
              component={CheckBox}
              label="group.create.members_read_only_field"
              on_placeholder="group.create.only_admins_can_post"
              off_placeholder="group.create.members_and_admins_can_post"
            />
            <CommunityField />
          </div>
        </Card>
        <CardWithHeader
          title="group.create.tags"
          icon={TagIcon}
          className={styles.tags_card}
        >
          <ImportantMessage i18nKey="group.create.specify_at_least_one_tag" />
          {createTagFields({
            fieldCount: 9,
            requiredCount: 1,
            language: 'en' /* todo: use group language, if/when they have one */
          })}
        </CardWithHeader>
      </Form>
    </ModalScreenLayout>
  )
}

export default CreateOrEditGroupPage
